import { render, staticRenderFns } from "./TimeAgoToolTip.vue?vue&type=template&id=5b6a6dd2&"
import script from "./TimeAgoToolTip.vue?vue&type=script&lang=ts&"
export * from "./TimeAgoToolTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports